import { render, staticRenderFns } from "./modalDetalleArchivo.vue?vue&type=template&id=dd6a7cf2&scoped=true"
import script from "./modalDetalleArchivo.vue?vue&type=script&lang=js"
export * from "./modalDetalleArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a7cf2",
  null
  
)

export default component.exports